export default Object.freeze({
  Error: -1,
  Success: 1,
  Running: 2,
});
